const pageState = ref<any | null>(null);

const modalStates = ref<Map<string, any>>(new Map());

export function usePageFiltersModal(windowId?: string) {
    return computed(() => {
        if (windowId) {
            return modalStates.value.get(windowId) || null;
        }
        return pageState.value;
    });
}

export function registerPageFiltersModal(state: any, windowId?: string) {
    if (windowId) {
        const newMap = new Map(modalStates.value);
        newMap.set(windowId, state);
        modalStates.value = newMap;
    } else {
        pageState.value = state;
    }
}

export function unregisterPageFiltersModal(windowId?: string) {
    if (windowId) {
        const newMap = new Map(modalStates.value);
        newMap.delete(windowId);
        modalStates.value = newMap;
    } else {
        pageState.value = null;
    }
}
